import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { IngredientsServices } from '../../services';

/**
 * Generated class for the DishPreparationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ingredient-create-observations',
    templateUrl: 'ingredient-create-observations.html',
})
export class IngredientCreateObservationsPage {

    ingredient_uid: string;
    ingredient_name: string;
    observations: string = '';

    _observations: string = '';

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public ingredientServices: IngredientsServices,) {
        this.ingredient_uid = this.navParams.get('ingredient_uid');
        this.ingredient_name = this.navParams.get('ingredient_name');
        this._observations = this.navParams.get('observations');

    }

    public getInitObservations(editor: any) {
        if (editor.html) {
            this.observations = editor.html;
        }
    }

    update() {
        this.ingredientServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
            'observations': this.observations,
            'updated_user': this.globals.user_name,
            'updated_at': new Date(),
        }).then(() => {
            //this.globals.GAtrackView('Dish', 'Dish - Preparation - Update', this.globals.restaurant.email, 'Create/Update', 'Update preparation', 'Dish', this.dish_name);
            this.navCtrl.pop();
        });
    }



}


// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-create/ingredient-create-observations/ingredient-create-observations.ts